module.exports = __webpack_public_path__ + "img/20250527.51d56708.png";